export default "__VITE_ASSET__Ddn6CusP__"